import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function CustomerInspectionsCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {

  $scope.showCustomerInspections = !!$scope.inspections.length;
  $scope.tableCacheKey           = 'customerInspections';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'inspection_number',
        header: {
          text: $translate.instant('INSPECTIONS_SPACE.INSPECTION_NUMBER')
        },
        width: '14%'
      },
      {
        field : 'inspection_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'inspection_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'inspectionStatus'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewInspection(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('INSPECTIONS_SPACE.NO_INSPECTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/customers/inspection_count/' + $scope.customer.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'inspection_date'
    }),
  };

  $scope.getInspections = ( params ) => {
    return workshopAPI.get('/customers/inspection_list', [
      $scope.customer.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(inspections => {
      $scope.inspections = inspections;

      return inspections;
    });
  };

  $scope.viewInspection = function (inspection) {
    $state.go('app.inspection', {
      customer_id: $scope.customer.id,
      id         : inspection.id,
      vehicle_id : inspection.vehicle_id
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $state.go('app.inspection', {
      customer_id: $scope.customer.id,
      id         : event.row.id,
      vehicle_id : event.row.vehicle_id
    });
  };
}
